module.exports = __webpack_public_path__ + "img/big_1_12.65ecd2fb.png";